import {
  PayeeEngagementType,
  PayerEngagementType
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The v1 `EngagementType` values, inlined as literals.
 *
 * Callers outside this module (Payees, RequirementDefinitions) still hand over
 * values read off v1 resources, and their string values differ from the v3
 * enums' rather than colliding. Matching them as literals keeps this helper
 * working for those callers without importing a legacy type into Payers; the
 * arm goes away once those modules migrate.
 */
const LEGACY_ENGAGEMENT_TYPE = {
  contractorVendor: "ContractorVendor",
  employerOfRecord: "EmployerOfRecord",
  agencyOfRecord: "AgencyOfRecord"
} as const;

/**
 * Human label for an engagement classification. Accepts the v3
 * `PayerEngagementType` / `PayeeEngagementType` and the legacy string values
 * above; an unrecognised value is returned verbatim.
 */
export function getEngagementLabelByType(
  type: PayerEngagementType | PayeeEngagementType | string | undefined,
  options?: { descriptive?: boolean }
): string {
  switch (type) {
    case LEGACY_ENGAGEMENT_TYPE.agencyOfRecord:
    case PayeeEngagementType.AGENT_OF_RECORD:
      return options?.descriptive ? "Agency of Record (AOR)" : "AOR";
    case LEGACY_ENGAGEMENT_TYPE.contractorVendor:
    case PayeeEngagementType.CONTRACTOR:
      return options?.descriptive ? "Independent contractor (IC)" : "IC";
    case LEGACY_ENGAGEMENT_TYPE.employerOfRecord:
    case PayeeEngagementType.EMPLOYEE_OF_RECORD:
      return options?.descriptive ? "Employer of Record (EOR)" : "EOR";
    case PayeeEngagementType.EMPLOYEE:
      return "Employee";
    default:
      return type ?? "";
  }
}
